import { Link } from "react-router-dom";
import { useConfig } from "@/context/ConfigContext";

function XLogo({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export default function Footer() {
  const config = useConfig();
  const isLive = config?.payment_mode === "live";
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-black/60" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="flex flex-col gap-8 md:flex-row md:justify-between">
          <div className="max-w-xs">
            <Link to="/" className="flex items-center gap-1.5">
              <span className="font-display text-2xl font-black tracking-tighter">FLIP</span>
              <span className="text-lg text-gold">↑</span>
            </Link>
            <p className="mt-2 text-xs leading-relaxed text-zinc-500">
              The people-powered crypto leaderboard. Every dollar verified on-chain — rank is earned in public.
            </p>
            <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-2">
              <span
                data-testid="footer-mode"
                className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${
                  isLive ? "border-positive/40 text-positive" : "border-gold/40 text-gold"
                }`}
              >
                {isLive ? "● Live mode" : "● Demo mode"}
              </span>
              <a
                href="https://x.com/backonflip_"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-x"
                className="inline-flex items-center gap-1.5 text-sm leading-none text-zinc-400 transition-colors hover:text-white"
              >
                <XLogo className="h-3.5 w-3.5 shrink-0" />
                @backonflip_
              </a>
            </div>
          </div>

          <nav className="flex flex-col gap-8 text-sm sm:flex-row sm:gap-16" aria-label="Footer">
            <div>
              <div className="mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-600">Board</div>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-zinc-400 transition-colors hover:text-white" data-testid="footer-tokens">Tokens</Link>
                <Link to="/callers" className="text-zinc-400 transition-colors hover:text-white" data-testid="footer-kols">KOLs</Link>
                <Link to="/backers" className="text-zinc-400 transition-colors hover:text-white" data-testid="footer-backers">Top backers</Link>
                <Link to="/stats" className="text-zinc-400 transition-colors hover:text-white" data-testid="footer-stats">Stats</Link>
              </div>
            </div>
            <div>
              <div className="mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-600">About</div>
              <div className="flex flex-col gap-2">
                <Link to="/rules" className="text-zinc-400 transition-colors hover:text-white" data-testid="footer-rules">Rules</Link>
                <Link to="/about" className="text-zinc-400 transition-colors hover:text-white" data-testid="footer-about">About</Link>
                <Link to="/stats" className="text-zinc-400 transition-colors hover:text-white" data-testid="footer-flips">Rank wars</Link>
              </div>
            </div>
          </nav>
        </div>

        <div className="mt-8 border-t border-white/5 pt-6 text-[11px] leading-relaxed text-zinc-600">
          © {year} FLIP. Crypto assets are volatile; backing an entity involves real risk of loss.
          Nothing on this site is financial advice. Contributions are irreversible on-chain transfers
          to entity treasuries — never send more than you can afford to lose.
        </div>
      </div>
    </footer>
  );
}
